import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

export default function useDataTransform(props, data) {
  let value = useDataValue({
    context: 'event_action',
    viewPath: props.viewPath,
  })
  return useMemo(() => {
    if (!data) return data
    let defaultValues = { selected: 'days', value: 0 }
    if (value.data.weeks) {
      defaultValues = { selected: 'weeks', value: value.data.weeks }
    }
    if (value.data.days) {
      defaultValues = { selected: 'days', value: value.data.days }
    }
    if (value.data.hours) {
      defaultValues = { selected: 'hours', value: value.data.hours }
    }
    if (value.data.minutes) {
      defaultValues = { selected: 'minutes', value: value.data.minutes }
    }
    return { ...data, ...defaultValues }
  }, [data])
}
